import { theme } from 'antd';

const { defaultAlgorithm, darkAlgorithm } = theme;

export const THEME_TYPES = {
  LIGHT: 'light',
  DARK: 'dark'
};

const baseConfig = {
  token: {
    // Используем CSS переменные Telegram для отступов
    padding: 'var(--tg-safe-area-inset-top, 16px)',
    margin: 'var(--tg-safe-area-inset-left, 16px)',
    // Основные цвета из Telegram WebApp
    fontFamily: 'var(--tg-theme-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif)',
  },
};

const lightTheme = {
  algorithm: defaultAlgorithm,
  token: {
    ...baseConfig.token,
    // Основные цвета
    colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
    colorPrimaryHover: 'var(--tg-theme-button-color, #4096ff)',
    colorPrimaryActive: 'var(--tg-theme-button-color, #0958d9)',
    colorPrimaryBg: 'rgba(22, 119, 255, 0.1)',
    colorPrimaryBgHover: 'rgba(22, 119, 255, 0.15)',
    
    // Фоны
    colorBgContainer: "#f5f5f5",
    colorBgLayout: "#f5f5f5",
    colorBgElevated: "#f5f5f5",
    
    // Текст
    colorText: '#1d1d1d',
    colorTextSecondary: '#666666',
    colorTextTertiary: '#999999',
    
    // Границы
    colorBorder: '#e8e8e8',
    colorBorderSecondary: '#f0f0f0',
    
    // Успех, предупреждения, ошибки
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: 'var(--tg-theme-link-color, #1677ff)',
    
    // Радиусы и размеры
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    
    // Специфичные настройки для компонентов
    handleColor: 'var(--tg-theme-button-color, #1677ff)',
    
    // Card компоненты
    colorFillAlter: 'var(--tg-theme-secondary-bg-color, #fafafa)',
    colorFillContent: '#ffffff',
    
    // Tag компоненты
    colorFillSecondary: '#f6f6f6',
    
    // Avatar компоненты
    colorTextLightSolid: '#ffffff',
    
    // Выделение выбранных элементов
    controlItemBgActive: '#e6f4ff',
    controlItemBgActiveHover: '#bae0ff',
    
    // Segmented компоненты
    colorBgTextHover: '#f5f5f5',
    colorBgTextActive: 'var(--tg-theme-button-color, #1677ff)',
  },
  components: {
    Card: {
      colorBgContainer: '#ffffff',
      colorBorder: '#e8e8e8',
      colorBorderSecondary: '#f0f0f0',
      paddingLG: 20,
      padding: 16,
      paddingSM: 12,
    },
    Input: {
      colorBgContainer: '#ffffff',
      colorBorder: '#e8e8e8',
      colorText: '#1d1d1d',
      colorTextPlaceholder: '#999999',
      activeBorderColor: 'var(--tg-theme-button-color, #1677ff)',
      hoverBorderColor: 'var(--tg-theme-button-color, #4096ff)',
    },
    Button: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      colorPrimaryHover: 'var(--tg-theme-button-color, #4096ff)',
      colorPrimaryActive: 'var(--tg-theme-button-color, #0958d9)',
      colorText: '#1d1d1d',
      colorBgContainer: '#ffffff',
      colorBorder: '#e8e8e8',
      colorIcon: 'var(--tg-theme-button-color, #1677ff)',
    },
    Tag: {
      colorText: '#1d1d1d',
      defaultBg: "#f5f5f5",
      colorBorder: 'var(--tg-theme-button-color, #1677ff)',
    },
    Badge: {
      colorBgContainer: 'var(--tg-theme-button-color, #1677ff)',
      colorText: '#ffffff',
    },
    Avatar: {
      colorBgContainer: '#f5f5f5',
      colorText: '#1d1d1d',
    },
    Descriptions: {
      colorText: '#1d1d1d',
      colorTextSecondary: '#666666',
      colorBgContainer: '#ffffff',
      colorBorder: '#e8e8e8',
    },
    Segmented: {
      colorBgLayout: '#f5f5f5',
      colorText: '#1d1d1d',
      colorTextLabel: '#1d1d1d',
      colorBgElevated: '#ffffff',
      itemSelectedBg: 'var(--tg-theme-button-color, #1677ff)',
      itemSelectedColor: '#ffffff',
    },
    Pagination: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      colorText: '#1d1d1d',
      colorBgContainer: '#ffffff',
    },
    Modal: {
      colorBgElevated: '#ffffff',
      colorText: '#1d1d1d',
      colorIcon: '#666666',
    },
    Spin: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
    },
    Slider: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      handleColor: 'var(--tg-theme-button-color, #1677ff)'
    },
    Steps: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      marginSM: 16,
    },
  },
};

const darkTheme = {
  algorithm: darkAlgorithm,
  token: {
    ...baseConfig.token,
    // Основные цвета
    colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
    colorPrimaryHover: 'var(--tg-theme-button-color, #4096ff)',
    colorPrimaryActive: 'var(--tg-theme-button-color, #0958d9)',
    colorPrimaryBg: 'rgba(22, 119, 255, 0.15)',
    colorPrimaryBgHover: 'rgba(22, 119, 255, 0.15)',
    
    
    // Фоны
    colorBgContainer: '#1d1d1d',
    colorBgLayout: '#1d1d1d',
    colorBgElevated: '#1d1d1d',
    
    // Текст
    colorText: '#ffffff',
    colorTextSecondary: '#a6a6a6',
    colorTextTertiary: '#737373',
    
    // Границы
    colorBorder: '#303030',
    colorBorderSecondary: '#262626',
    colorBorderBg: '#303030',
    
    // Успех, предупреждения, ошибки
    colorSuccess: '#73d13d',
    colorWarning: '#ffc53d',
    colorError: '#ff7875',
    colorInfo: '#40a9ff',
    
    // Радиусы и размеры
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    
    // Специфичные настройки для компонентов
    handleColor: 'var(--tg-theme-button-color, #1677ff)',
    
    // Card компоненты
    colorFillAlter: 'var(--tg-theme-secondary-bg-color, #262626)',
    colorFillContent: '#1d1d1d',
    
    // Tag компоненты
    colorFillSecondary: '#303030',
    
    // Avatar компоненты
    colorTextLightSolid: '#ffffff',
    
    // Выделение выбранных элементов
    controlItemBgActive: '#111b26',
    controlItemBgActiveHover: '#0f1419',
    
    // Segmented компоненты
    colorBgTextHover: '#303030',
    colorBgTextActive: 'var(--tg-theme-button-color, #1677ff)',
  },
  components: {
    Card: {
      colorBgContainer: '#262626',
      colorBorder: '#303030',
      colorBorderSecondary: '#1d1d1d',
      paddingLG: 20,
      padding: 16,
      paddingSM: 12,
    },
    Input: {
      colorBgContainer: '#1d1d1d',
      colorBorder: '#303030',
      colorText: '#ffffff',
      colorTextPlaceholder: '#737373',
      activeBorderColor: 'var(--tg-theme-button-color, #1677ff)',
      hoverBorderColor: 'var(--tg-theme-button-color, #4096ff)',
    },
    Button: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      colorPrimaryHover: 'var(--tg-theme-button-color, #4096ff)',
      colorPrimaryActive: 'var(--tg-theme-button-color, #0958d9)',
      colorText: '#ffffff',
      colorBgContainer: '#1d1d1d',
      colorBorder: '#303030',
      colorIcon: 'var(--tg-theme-button-color, #1677ff)',
    },
    Tag: {
      colorText: '#ffffff',
      defaultBg: "#1d1d1d",
      colorBorder: 'var(--tg-theme-button-color, #1677ff)',
    },
    Badge: {
      colorBgContainer: 'var(--tg-theme-button-color, #1677ff)',
      colorText: '#ffffff',
    },
    Avatar: {
      colorBgContainer: '#303030',
      colorText: '#ffffff',
    },
    Descriptions: {
      colorText: '#ffffff',
      colorTextSecondary: '#a6a6a6',
      colorBgContainer: '#1d1d1d',
      colorBorder: '#303030',
    },
    Segmented: {
      colorBgLayout: '#1d1d1d',
      colorText: '#ffffff',
      colorTextLabel: '#ffffff',
      colorBgElevated: '#1d1d1d',
      itemSelectedBg: 'var(--tg-theme-button-color, #1677ff)',
      itemSelectedColor: '#ffffff',
    },
    Pagination: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      colorText: '#ffffff',
      colorBgContainer: '#1d1d1d',
    },
    Modal: {
      colorBgElevated: '#1d1d1d',
      colorText: '#ffffff',
      colorIcon: '#a6a6a6',
    },
    Spin: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
    },
    Slider: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      handleColor: 'var(--tg-theme-button-color, #1677ff)'
    },
    Steps: {
      colorPrimary: 'var(--tg-theme-button-color, #1677ff)',
      marginSM: 16,
    },
  },
};

export const getThemeConfig = (currentTheme) => {
  switch (currentTheme) {
    case THEME_TYPES.LIGHT:
      return lightTheme;
    case THEME_TYPES.DARK:
      return darkTheme;
    default:
      return lightTheme;
  }
}; 